import { useApiQuery } from './useApiQuery';
import { operationCostsApi } from '../services/operationCostsApi';
import type { OperationCosts } from '../services/operationCostsApi';
import { custoDeOperacao } from '../components/CreditAlert/lib/custoDeOperacao';

const CINCO_MINUTOS = 5 * 60 * 1000;

/**
 * O catálogo de custos por operação (`GET /config/operation-costs`).
 *
 * A REGRA de leitura mora em `lib/custoDeOperacao` (pura, ao lado de
 * `lib/saldoDeCreditos`): `null` — nunca 0 — quando a leitura não respondeu
 * OU quando o slug não está no catálogo, e `0` DECLARADO continua sendo 0.
 * Este hook é só o transporte; ele delega e não decide nada, porque a MESMA
 * pergunta é feita pelo popover (que exibe o preço) e pelo `DealBriefing`
 * (que decide se o botão abre) — duas cópias divergiriam na primeira edição
 * de uma só.
 *
 * Mesmo TTL do `Cache-Control` que o BFF emite (5 min) — o catálogo é
 * público e igual para todo mundo.
 */
export function useOperationCosts() {
  const { data, isLoading, error } = useApiQuery<OperationCosts>(
    ['config', 'operation-costs'],
    () => operationCostsApi.get(),
    { staleTime: CINCO_MINUTOS },
  );

  const custoDe = (slug: string): number | null => custoDeOperacao(data, slug);

  return { custos: data, custoDe, conhecido: !!data, isLoading, error };
}
